export default "__VITE_ASSET__4cd09a7d__"